module.exports = __webpack_public_path__ + "static/butchi-ce103e01fdfa7028ba3ea70559283195.jpg";